import * as types from '@phoenix/store/mutations-types';

const views = {
  DEFAULT: 'DefaultView',
  SELECT_WATCH: 'SelectWatchView',
  ENTER_REFERENCE: 'EnterReferenceView',
  REFERENCE_GUIDE: 'ReferenceGuideView',
};

const initialState = {
  views,
  currentView: views.DEFAULT,
  references: [],
  selectionItems: [],
  displayOnlySelectWatch: false,
  isOnEngravingToolPage: false,
  engravingToolUrl: null,
  reference: null,
  referenceType: 'NR',
};

const getters = {
  isDefaultView: (state) => state.currentView === views.DEFAULT,
};

const actions = {
  setView({ commit }, { view }) {
    commit(types.ENGRAVING_TOOL_MODAL_SET_CURRENT_VIEW, { view });
  },

  setData({ commit }, { references, selectionItems, displayOnlySelectWatch, isOnEngravingToolPage, engravingToolUrl }) {
    commit(types.ENGRAVING_TOOL_MODAL_SET_DATA, {
      references,
      selectionItems,
      displayOnlySelectWatch,
      isOnEngravingToolPage,
      engravingToolUrl,
    });
  },

  setReference({ commit }, { reference, referenceType }) {
    commit(types.ENGRAVING_TOOL_MODAL_SET_REFERENCE, { reference, referenceType });
  },
};

const mutations = {
  [types.ENGRAVING_TOOL_MODAL_SET_CURRENT_VIEW](state, { view }) {
    state.currentView = view;
  },

  [types.ENGRAVING_TOOL_MODAL_SET_DATA](
    state,
    { references, selectionItems, displayOnlySelectWatch, isOnEngravingToolPage, engravingToolUrl },
  ) {
    state.references = references;
    state.selectionItems = selectionItems;
    state.displayOnlySelectWatch = displayOnlySelectWatch;
    state.isOnEngravingToolPage = isOnEngravingToolPage;
    state.engravingToolUrl = engravingToolUrl;
  },

  [types.ENGRAVING_TOOL_MODAL_SET_REFERENCE](state, { reference, referenceType }) {
    state.reference = reference;
    state.referenceType = referenceType;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
